<style>
	.fade-enter-active, .fade-leave-active {
		transition: opacity .3s;
		position: relative;
		z-index: 1050;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}
</style>

<template>
	<transition name="fade">
		<div v-if="shown">
			<div class="modal-backdrop in"></div>
			<div class="modal dynamic in" style="display: block">
				<div v-if="shown" class="modal-dialog modal-lg ui-draggable">
					<div class="modal-content">
						<div class="modal-header ui-draggable-handle"><button type="button" class="close" data-dismiss="modal" @click="$emit('cancel')"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>
							<h4 class="modal-title">Opdater status</h4>
						</div>
						<div class="modal-body">
							<div style="padding: 0px 15px;">
								<div class="row">
									<div v-for="(status_type, id) in status_types" class="col-md-6" style="margin-bottom: 15px;">
										<div class="btn btn-lg btn-block" :class="[status_class(status_type.statustype), {active: (status_type.statustype === employee.status.status)}]" @click="set_status(status_type.statustype)" style="position: relative; font-size: 2em;">
											<i v-if="status_active(employee.status.status, status_type.statustype)" class="fa fa-lg fa-check" style="position: absolute; top:.5em; left: .5em;"></i>{{status_type.navn}}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-danger" @click="$emit('cancel')" onclick="return false;">Annullér</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	export default {
		name: "status-picker",
		props: {
			'status_types': null,
			'employee': {
				default: {},
			},
		},
		data: function(){return {
			// status_types: {},
			// employee: {},
			isin: false,
		}},
		methods: {
			set_status: function(status) {
				var employee = this.employee.employee;
				var current_status = this.employee.status.status;
				var img = employee+".jpg";
				if (employee == "KH") {
					img = "Kim-Harris.jpg";
				}
				// this.departments[this.selected_department][employee].status.status = status;
				if (current_status != status) {
					var self = this;
					var p = promise_dialog({
						title: "Bekræft",
						body: "<style>.modal"+"-body{overflow:auto}</style><img src='https://vikiallo.dk/wp-content/uploads/"+img+"' style='float:left;max-height:170px;margin-right:20px;' /><h2>"+this.employee.name+"</h2><h3>"+this.status_types[status].navn+"</h3><textarea id='status_notes' class='form-control' style='width:300px;' placeholder='Notat på stempling'></textarea>",
						buttons: [
							{title:"OK", style: "success btn-lg pull-left", resolve: "confirmed", attributes: {style: 'min-width: 49%;'}},
							{title:"Annuller", style: "danger btn-lg", reject: "cancelled2", attributes: {style: 'min-width: 49%;'}},
						],
					}).then(() => {
						return Promise.resolve(jQuery.post("./employee/update_status/"+employee+"/"+status, {notes: jQuery("#status_notes").val()})).then((data) => {
							var msg = alertManager.success("Status opdateret").showFloated();
							this.employee.status.status = status;
							if (typeof menu == "object") {
								menu.employee.status = data.departments[menu.employee.department][menu.employee.employee].status;
							}
							this.$emit('change', status);
							// jQuery(this.$el).closest(".modal").data("promise").resolve("Status opdateret");
							// jQuery(this.$el).closest(".modal").modal("hide");
							setTimeout(function(){
								msg.close();
							}, 2000);
						});
					}, ()=>{
						var msg = alertManager.error("Status ikke opdateret!").showFloated();
						setTimeout(function(){
							msg.close();
						}, 2000);
					})["catch"](function(err){
						var msg = alertManager.error("Status ikke opdateret, muligvis på grund af netværksfejl!").showFloated();
						this.$emit('error', err);
						// console.log(err);
					});

					return p;
				}
			},
			status_class: function(status) {
				switch (status+"") {
					case "0": return "btn-danger";
					case "2": return "btn-success";
					case "3": return "btn-danger";
					case "4": return "btn-danger";
					case "5": return "btn-info";
					case "6": return "btn-warning";
					case "7": return "btn-success";
					case "10": return "btn-warning";
					case "11": return "btn-warning";
					default: return "btn-primary";
				}
			},
			status_active: function(employee, status) {
				return (status === this.employee.status.status);
			},
			beforeEnter: function (el) {
				el.style.opacity = 0
				el.style.height = 0
			},
		},
		computed: {
			shown: function(){
				return !!Object.keys(this.employee).length;
			},
		},
		watch: {
			shown: function(){
				/*this.$nextTick(()=>{
					setImmediate(()=>{
						this.isin = this.shown;
					})
				})*/
				setTimeout(function(){
					if(jQuery(".modal").length){
						jQuery("body").addClass("modal-open");
					}
					else {
						jQuery("body").removeClass("modal-open");
					}
				}, 100);
			}
		}
	};
</script>


// WEBPACK FOOTER //
// status-picker.vue?5259844d